/* ==========================================================================
   Q4 — Pastilles photo des couleurs sur les cartes produits
   - Survol (souris) : prévisualise la couleur sur l'image de la carte
   - Clic / tap : sélectionne la couleur, met à jour l'image et les liens de la carte
   Délégation d'événements sur le document : fonctionne aussi pour les cartes chargées
   dynamiquement (filtres, pagination, recherche, recommandations).
   ========================================================================== */
(() => {
  if (window.__q4ColorSwatches) return;
  window.__q4ColorSwatches = true;

  const SWATCH = '.q4-swatch';
  const preloaded = new Set();

  const getCard = (el) => el.closest('product-card, .product-card');
  const getImage = (card) => card && card.querySelector('.product-card__image--primary');

  const productPath = (group) => {
    const url = group && group.getAttribute('data-product-url');
    if (!url) return null;
    const match = url.match(/\/products\/[^/?#]+/);
    return match ? match[0] : null;
  };

  const productLinks = (card, group) => {
    const path = productPath(group);
    if (!path) return [];
    return Array.from(card.querySelectorAll('a[href]')).filter((a) => {
      if (a.closest('.q4-swatches')) return false;
      const href = a.getAttribute('data-q4-orig-href') || a.getAttribute('href') || '';
      return href.split('?')[0].split('#')[0].endsWith(path);
    });
  };

  const rememberOriginal = (card) => {
    const img = getImage(card);
    if (!img || img.hasAttribute('data-q4-orig-src')) return;
    img.setAttribute('data-q4-orig-src', img.getAttribute('src') || '');
    img.setAttribute('data-q4-orig-srcset', img.getAttribute('srcset') || '');
  };

  const showImage = (card, src, srcset) => {
    const img = getImage(card);
    if (!img || !src) return;
    rememberOriginal(card);
    if (img.getAttribute('src') === src) return;
    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', src);
    img.removeAttribute('loading');
  };

  const showSwatch = (card, swatch) => {
    if (swatch.dataset.src) showImage(card, swatch.dataset.src, swatch.dataset.srcset);
  };

  const restore = (card) => {
    const active = card.querySelector(SWATCH + '[aria-pressed="true"]');
    if (active && active.dataset.src) {
      showSwatch(card, active);
      return;
    }
    const img = getImage(card);
    if (!img || !img.hasAttribute('data-q4-orig-src')) return;
    showImage(card, img.getAttribute('data-q4-orig-src'), img.getAttribute('data-q4-orig-srcset'));
  };

  const preload = (group) => {
    group.querySelectorAll(SWATCH + '[data-src]').forEach((swatch) => {
      const src = swatch.dataset.src;
      if (preloaded.has(src)) return;
      preloaded.add(src);
      const image = new Image();
      image.decoding = 'async';
      if (swatch.dataset.srcset) {
        image.sizes = (getImage(getCard(swatch)) || {}).sizes || '';
        image.srcset = swatch.dataset.srcset;
      }
      image.src = src;
    });
  };

  const select = (swatch) => {
    const card = getCard(swatch);
    const group = swatch.closest('.q4-swatches');
    if (!card || !group) return;

    rememberOriginal(card);

    group.querySelectorAll(SWATCH).forEach((s) => {
      s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
    });

    showSwatch(card, swatch);
    card.classList.add('q4-variant-selected');

    // Les liens de la carte (image, titre) ouvrent désormais la couleur choisie
    const url = swatch.dataset.variantUrl;
    if (url) {
      productLinks(card, group).forEach((a) => {
        if (!a.hasAttribute('data-q4-orig-href')) a.setAttribute('data-q4-orig-href', a.getAttribute('href'));
        a.setAttribute('href', url);
      });
    }

    // L'achat rapide (+) s'ouvre sur la couleur choisie
    const variantId = swatch.dataset.variantId;
    const modal = card.querySelector('quick-buy-modal[handle]');
    if (modal && variantId) {
      const handle = modal.getAttribute('handle').split('?')[0];
      modal.setAttribute('handle', `${handle}?variant=${variantId}`);
    }
  };

  // Survol à la souris : aperçu temporaire
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const group = target.closest('.q4-swatches');
    if (group && !group.hasAttribute('data-q4-preloaded')) {
      group.setAttribute('data-q4-preloaded', '');
      preload(group);
    }

    const swatch = target.closest(SWATCH);
    if (!swatch) return;
    const card = getCard(swatch);
    if (card) showSwatch(card, swatch);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const target = event.target instanceof Element ? event.target : null;
    const swatch = target && target.closest(SWATCH);
    if (!swatch) return;
    const related = event.relatedTarget instanceof Element ? event.relatedTarget.closest(SWATCH) : null;
    if (related) return; // passage direct d'une pastille à l'autre
    const card = getCard(swatch);
    if (card) restore(card);
  });

  // Clic / tap / clavier : sélection
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const swatch = target && target.closest(SWATCH);
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    select(swatch);
  });

  // Clavier : aperçu au focus, retour à l'état choisi en sortant
  document.addEventListener('focusin', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const swatch = target && target.closest(SWATCH);
    if (!swatch || !swatch.matches(':focus-visible')) return;
    const card = getCard(swatch);
    if (card) showSwatch(card, swatch);
  });

  document.addEventListener('focusout', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const swatch = target && target.closest(SWATCH);
    if (!swatch) return;
    const related = event.relatedTarget instanceof Element ? event.relatedTarget.closest(SWATCH) : null;
    if (related) return;
    const card = getCard(swatch);
    if (card) restore(card);
  });
})();

/* ==========================================================================
   Q4 — Guide des tailles : ouverture / fermeture de la fenêtre et bascule CM / INCHES
   ========================================================================== */
(() => {
  if (window.__q4SizeGuide) return;
  window.__q4SizeGuide = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const opener = target.closest('[data-q4-sg-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.getAttribute('data-q4-sg-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    if (target.closest('[data-q4-sg-close]')) {
      target.closest('dialog')?.close();
      return;
    }

    // Clic sur le fond sombre : fermer
    if (target.matches('dialog.q4-sg')) {
      const rect = target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) target.close();
      return;
    }

    const unit = target.closest('[data-q4-unit]');
    if (unit) {
      const dialog = unit.closest('dialog');
      const value = unit.getAttribute('data-q4-unit');
      dialog.querySelectorAll('[data-q4-unit]').forEach((b) => b.setAttribute('aria-selected', b === unit ? 'true' : 'false'));
      dialog.querySelectorAll('.q4-sg__table').forEach((t) => t.setAttribute('data-q4-current', value));
    }
  });
})();
